import React from 'react';
import { Smartphone, DollarSign, Phone, TrendingUp, Shield } from 'lucide-react';

const AppSection = () => {
  const appFeatures = [
    {
      icon: DollarSign,
      title: "Financeiro",
      description: "Acompanhe suas faturas, pagamentos e histórico financeiro"
    },
    {
      icon: Phone,
      title: "Contatos",
      description: "Acesso rápido aos canais de atendimento da empresa"
    },
    {
      icon: TrendingUp,
      title: "Consumo",
      description: "Monitore seu consumo de internet em tempo real"
    },
    {
      icon: Shield,
      title: "Liberação de Confiança",
      description: "Solicite liberação de serviços de forma rápida e prática"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-orange-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <div className="flex items-center mb-4">
              <Smartphone className="text-orange-500 mr-3" size={40} />
              <h2 className="text-4xl md:text-5xl font-bold text-gray-800">
                Baixe nosso App
              </h2>
            </div>
            
            <p className="text-xl text-gray-600 mb-8">
              Gerencie sua conta de forma prática e rápida pelo celular!
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {appFeatures.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={index}
                    className="flex items-start p-4 bg-white rounded-lg shadow-md"
                  >
                    <div className="bg-orange-100 p-3 rounded-full mr-4">
                      <Icon className="text-orange-500" size={24} />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 mb-1">{feature.title}</h3>
                      <p className="text-sm text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Download Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://apps.apple.com/app/opalink/id6758806645"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg className="w-8 h-8 mr-3" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                <div className="text-left">
                  <div className="text-xs">Disponível na</div>
                  <div className="text-lg font-semibold -mt-1">App Store</div>
                </div>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.provenduz.opalink"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg className="w-8 h-8 mr-3" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                <div className="text-left">
                  <div className="text-xs">Disponível no</div>
                  <div className="text-lg font-semibold -mt-1">Google Play</div>
                </div>
              </a>
            </div>
          </div>

          {/* App Screenshot */}
          <div className="flex justify-center items-center">
            <div className="relative max-w-sm w-full">
              <img 
                src="https://customer-assets.emergentagent.com/job_fiberweb-clone/artifacts/1nw3rdfp_WhatsApp%20Image%202026-02-12%20at%2010.20.57.jpeg"
                alt="App OpaLink"
                className="w-full h-auto max-h-[500px] object-contain rounded-3xl shadow-2xl"
              />
              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 bg-white rounded-lg shadow-lg p-3 hidden lg:block">
                <DollarSign className="text-green-500" size={28} />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white rounded-lg shadow-lg p-3 hidden lg:block">
                <TrendingUp className="text-blue-500" size={28} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppSection;
